import { NotifyHelper } from "../../../helpers/toast";
import { eThoiGianHocLopHCActionsObj } from "../../action-types/category/IThoiGianHocLopHCActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thoiGianHocLopHCActions = {
    ...generateActions(eThoiGianHocLopHCActionsObj, "THOI_GIAN_HOC_LOP_HC"),
    ...generateActionForKey(eThoiGianHocLopHCActionsObj, "THOI_GIAN_HOC_LOP_HC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eThoiGianHocLopHCActionsObj, "THOI_GIAN_HOC_LOP_HC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eThoiGianHocLopHCActionsObj, "THOI_GIAN_HOC_LOP_HC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eThoiGianHocLopHCActionsObj, "THOI_GIAN_HOC_LOP_HC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
